export const SIGNUP_FORM_URL = 'https://b24-x3d5i3.bitrix24.site/crm_form_622dh';
export const QUESTION_CHAT_URL = 'https://max.ru/join/Y69oKv-Pd9Ys8Zc4uRIBnHIFTrc-JE1cnGOk6UJ_-nM';
export const QUESTION_FEEDBACK_FORM_URL = 'https://forms.yandex.ru/u/69ef050190fa7b69fd8607ef';

